export const environment = window.location.hostname === 'localhost' ? 'development' : 'production';